import {BatchSchema} from 'constants/SampleConstants';
import {SCHEMA_ID_REQUEST_TASK_SCHEMA_ALL} from 'requests/tasks/RequestTaskConstants';
import {Schema} from 'schemas/SchemaConstants';
import {isRequestSchema} from 'schemas/SchemaPredicates';
import {Filter, FilterErrors, FilterKey} from 'search/SearchConstants';

export default function validateRequestFilters(
  filters: Array<Filter>,
  selectedSchema: Schema | BatchSchema | null
): FilterErrors {
  return filters.map((filter) => {
    if (filter.key === FilterKey.REQUEST_TASK_SCHEMA) {
      const value = filter.value as string;
      if (selectedSchema && isRequestSchema(selectedSchema)) {
        if (
          value &&
          value !== SCHEMA_ID_REQUEST_TASK_SCHEMA_ALL &&
          !selectedSchema.requestTaskSchemaIds.includes(value)
        ) {
          return 'The task is not supported with the selected type.';
        }
      }
    }
    return null;
  });
}
